import {
    ValidationResult,
    getFileExtension,
    createFailure,
    validationFailed,
    validationSuccessful
} from "sprint-common-web";

import { isAudioFile } from "../../content-ingestion/common/audioExtensions";
import { isZipDvbFile } from "../../content-ingestion/common/isZipDvbFile";
import { isSubtitlesFile } from "../../content-ingestion/common/subtitleExtensions";
import { isVideoFile } from "../../content-ingestion/common/videoExtensions";
import { RecordType } from "../types/RecordType";

type FileValidator = (extension: string) => boolean;

const fileValidators: Record<RecordType, FileValidator> = {
    [RecordType.Video]: isVideoFile,
    [RecordType.Subtitle]: (extension) => isSubtitlesFile(extension) || isZipDvbFile(extension),
    [RecordType.Audio]: isAudioFile
};

const errorMessages: Record<RecordType, string> = {
    [RecordType.Video]: "File's extension is not on list of supported video files",
    [RecordType.Subtitle]: "File's extension is not on list of supported subtitle files",
    [RecordType.Audio]: "File's extension is not on list of supported audio files"
};

export const validateFileExtension = (filename: string, recordType: RecordType): ValidationResult => {
    const extension = getFileExtension(filename);

    const isValid = fileValidators[recordType]?.(extension);
    if (!isValid) {
        const failure = createFailure(errorMessages[recordType], "filename.NotSupportedExtension");
        return validationFailed([failure]);
    }

    return validationSuccessful();
};
